<app-layout [isProducerArea]="true">
  <app-page-header [title]="'Minhas vendas'" [titleIcon]="'pi pi-money-bill'"
    [subtitle]="'Visualize suas últimas vendas.'" [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Últimas vendas', icon: 'pi pi-money-bill' },
    ]"></app-page-header>
  <div class="container-fluid my-sales">
    <section class="my-sales__filters">
        <div class="my-sales__filters-grid">
          <div class="my-sales__filter-field">
            <label for="eventNameFilter" class="form-label">Evento</label>
            <input id="eventNameFilter" type="text" class="form-control" placeholder="Nome do evento"
              [(ngModel)]="filterForm.event_name" (keyup.enter)="applyFilters()" />
          </div>

          <div class="my-sales__filter-field">
            <label for="buyerFilter" class="form-label">Comprador</label>
            <input id="buyerFilter" type="text" class="form-control" placeholder="Nome do comprador"
              [(ngModel)]="filterForm.name" (keyup.enter)="applyFilters()" />
          </div>

          <div class="my-sales__filter-field">
            <label for="sellerFilter" class="form-label">Vendedor</label>
            <select id="sellerFilter" class="form-select" [(ngModel)]="filterForm.seller_id">
              <option [ngValue]="undefined">Todos os vendedores</option>
              @for (seller of sellers; track seller.id) {
              <option [ngValue]="seller.id">{{ seller.label }}</option>
              }
            </select>
          </div>

          <div class="my-sales__filter-field">
            <label for="statusFilter" class="form-label">Status</label>
            <select id="statusFilter" class="form-select" [(ngModel)]="filterForm.status">
              <option value="">Todos os status</option>
              @for (status of statusOptions; track status.value) {
              <option [value]="status.value">{{ status.label }}</option>
              }
            </select>
          </div>

          <div class="my-sales__filters-actions">
            <app-button styleType="outlined" [disabled]="!hasActiveFilters" (btnClick)="clearFilters()">
              Limpar filtros
            </app-button>
            <app-button (btnClick)="applyFilters()"> Aplicar filtros </app-button>
          </div>
        </div>
      </section>

    <section class="my-sales__table-section">
      <app-last-sales-table [sales]="sales$ | async" [showSeeAllLink]="false" [showPagination]="true"
        [first]="paginatorFirst" [rows]="paginatorRows" (pageChange)="handleSalesPageChange($event)"
        (saleDetailsClick)="handleSaleDetailsClick($event)" />
    </section>
  </div>

  @if (loadingOrderDetails) {
  <app-loading />
  }
</app-layout>